import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { CustomReuseStrategy } from '@core/classes/custom-reuse-estrategy';
import { CanActivateRouteGuard } from '@core/guards/can-activate-route.guard';


const routes: Routes = [



  // Rotas Liberadas Com Desvio do Fluxo padrao
  /* ************************************************************************************************************************* */
  {
    path: 'f/checkout',
    loadChildren: () => import('./modules/fin-checkout/fin-checkout.module').then((m) => m.FinCheckoutModule),
    data: {
      reuseComponent: true
    },
  },
  {
    path: 'c/validate-new-cad',
    loadChildren: () => import('./modules/clinic-validate/clinic-validate.module').then((m) => m.ClinicValidateModule),
    data: {
      reuseComponent: true
    },
  },
  /* ************************************************************************************************************************* */


  // Rotas Liberadas
  /* ************************************************************************************************************************* */
  {
    path: 'login',
    loadChildren: () => import('./modules/auth-login/auth-login.module').then((m) => m.AuthLoginModule),
  },
  {
    path: 'register',
    loadChildren: () => import('./modules/auth-register/auth-register.module').then((m) => m.AuthRegisterModule),
  },
  {
    path: 'register-ok',
    loadChildren: () => import('./modules/auth-register-ok/auth-register-ok.module').then((m) => m.AuthRegisterOkModule),
  },
  {
    path: 'reset-password-req',
    loadChildren: () => import('./modules/auth-reset-pass-req/auth-reset-pass-req.module').then((m) => m.AuthResetPassReqModule),
  },
  {
    path: 'reset-password-resp',
    loadChildren: () => import('./modules/auth-reset-pass-resp/auth-reset-pass-resp.module').then((m) => m.AuthResetPassRespModule),
  },
  {
    path: 'terms',
    loadChildren: () => import('./modules/auth-terms/auth-terms.module').then((m) => m.AuthTermsModule),
  },
  {
    path: 'change-account-mail-resp',
    loadChildren: () => import('./modules/auth-change-account-mail-resp/auth-change-account-mail-resp.module').then((m) => m.AuthChangeAccountMailRespModule),
  },
  /* ************************************************************************************************************************* */




  // Rotas Protegidas
  /* ************************************************************************************************************************* */

  // Main
  //-----------------------------------------------------------------------------------
  {
    path: '',
    canActivate: [CanActivateRouteGuard],
    pathMatch: 'full',
    loadChildren: () => import('./modules/main-home/main-home.module').then((m) => m.MainHomeModule),
  },
  {
    path: 'home',
    redirectTo: '',
    pathMatch: 'full',
  },
  //-----------------------------------------------------------------------------------


  // Módulo ADMIN
  //-----------------------------------------------------------------------------------
  {
    path: 'admin',
    canActivate: [CanActivateRouteGuard],
    loadChildren: () => import('./modules/admin/admin.module').then((m) => m.AdminModule),
    data: {
      reuseComponent: true
    },
  },
  //-----------------------------------------------------------------------------------



  {
    path: 'int/totvs/ped-venda',
    canActivate: [CanActivateRouteGuard],
    loadChildren: () => import('./modules/int-totvs-ped-vendas/int-totvs-ped-vendas.module').then((m) => m.IntTotvsPedVendasModule),
    data: {
      reuseComponent: true
    },
  },

  {
    path: 'f/cred',
    canActivate: [CanActivateRouteGuard],
    loadChildren: () => import('./modules/fin-cred/fin-cred.module').then((m) => m.FinCredModule),
    data: {
      reuseComponent: true
    },
  },
  {
    path: 'f/fat',
    canActivate: [CanActivateRouteGuard],
    loadChildren: () => import('./modules/fin-fat/fin-fat.module').then((m) => m.FinFatModule),
    data: {
      reuseComponent: true
    },
  },
  {
    path: 'f/calc',
    canActivate: [CanActivateRouteGuard],
    loadChildren: () => import('./modules/fin-calc/fin-calc.module').then((m) => m.FinCalcModule),
    data: {
      reuseComponent: true
    },
  },
  /* ************************************************************************************************************************* */


  // Qualquer Outra Rota
  /* ************************************************************************************************************************* */
  {
    path: '503',
    loadChildren: () => import('./modules/main-unavailable/main-unavailable.module').then((m) => m.MainUnavailableModule),
    pathMatch: 'full',
  },
  {
    path: '400',
    loadChildren: () => import('./modules/main-bad-request/main-bad-request.module').then((m) => m.MainBadRequestModule),
    pathMatch: 'full',
  },
  {
    path: '**',
    loadChildren: () => import('./modules/main-not-found/main-not-found.module').then((m) => m.MainNotFoundModule),
  },
  /* ************************************************************************************************************************* */
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: false, //hide fragment
    onSameUrlNavigation: 'reload',
  })],
  exports: [RouterModule],
  providers:[
    {provide: RouteReuseStrategy, useClass: CustomReuseStrategy}
  ]
})
export class AppRoutingModule { }
